var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-content-content tabs-content-buttons"},_vm._l((_vm.types),function(type){return _c('type',{key:type.name,attrs:{"icon":type.icon,"title":type.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }